import { render, staticRenderFns } from "./StatsRegistrations.vue?vue&type=template&id=648b6d30"
import script from "./StatsRegistrations.vue?vue&type=script&lang=ts"
export * from "./StatsRegistrations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports